import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export function useGetOfferPackages(offerId: string | undefined, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<Array<App.Package>>({
    queryKey: [...offerQueryKeys.detail(offerId ?? ''), 'packages'] as const,
    queryFn: async () => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      const response = await OffersService.getOffer(offerId);
      return response?.result?.packages ?? [];
    },
    enabled: enabled && !!offerId,
  });
}
